<template>
  <div class="view__card">
    <List v-model="query" :columns="columns" :tableData="tableData">
      <template v-slot:slot_state="{ row }">
        <span>{{ row.state ? '启用' : '禁用' }}</span>
      </template>
      <template v-slot:slot_opt="{ row }">
        <el-button type="text" @click="edit(row.id)"> 编辑 </el-button>
        <el-button type="text" @click="disableBtn(row.id)">
          {{ row.state ? '禁用' : '启用' }}
        </el-button>
        <el-button type="text" @click="del(row.id)" v-if="row.userNum === 0">
          删除
        </el-button>
      </template>
      <template v-slot:footertool>
        <el-button type="primary" @click="addArticle">
          新增角色
        </el-button>
      </template>
    </List>
  </div>
</template>
<script>
/**
 * @author xingzhesun
 * @name   roleList
 * @desc   健康管理-设置-角色列表
 * @props  none
 * @emit   none
 */
import { List, mixin } from '@/components'
import { roleList, stateRole, delRole } from '@/api/healthApi/rolesSet'

export default {
  components: {
    List,
  },
  mixins: [mixin([{ fetchListFunction: roleList }])],
  data() {
    return {
      query: {
        pageSize: 10,
        currentNum: 1,
      },
      columns: {
        index: {
          hidden: true,
        },
        opt: {
          prop: 'slot_opt',
          minWidth: 90,
        },
        state: {
          prop: 'slot_state',
        },
      },
    }
  },

  methods: {
    //删除
    del(id) {
      this.$confirm('是否确认删除？', '提示', {
        type: 'warning',
      }).then(async () => {
        await delRole({ roleId: id })
        //重新拉取数据
        await this.$_fetchTableData()
        this.$message.success('删除成功！')
      })
    },
    edit(id) {
      this.$router.push({
        path: '/setUp/roleSet/editRole',
        query: {
          roleId: id,
        },
      })
    },
    addArticle() {
      console.log('新增角色')
      this.$router.push('/setUp/roleSet/addRole')
    },
    //角色状态改变
    async disableBtn(id) {
      await stateRole({ roleId: id })
      //重新拉取数据
      await this.$_fetchTableData()
      this.$message.success('操作成功！')
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}
</style>
